<template>
  <div
    @mouseleave="hideHeader"
    @mouseenter="showHeader"
    :active="active"
    class="item page-nav-item"
    :class="{ 'empty-page': position == 0 }"
    @click="goToPage()"
    :position="position"
  >
    <span class="text">{{ letter }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerTimer: null,
    };
  },
  props: ["id", "name", "letter", "position", "active"],
  computed: {
    title() {
      return this.letter;
    },
    tooltip() {
      return ""; // this.position == 0 ? "דף ריק" : "";
    },
  },
  methods: {
    async goToPage() {
      this.$store.state.tabsManager.userClick = true;
      this.hideHeader();
      this.$emit("click", this.id);
    },
    showHeader() {
      if (this.position == 0) return;
      this.$emit("mouseenter", {
        pageId: this.name,
        top: this.$el.getBoundingClientRect().top,
        left: this.$el.getBoundingClientRect().left,
        pos: this.position,
      });
    },
    hideHeader() {
      this.$emit("mouseleave");
    },
  },
  destroyed() {
    if (this.headerTimer) clearTimeout(this.headerTimer);
  },
};
</script>

<style lang="scss" scoped>
.item {
  text-align: right;
}
.empty-page {
  color: lightgrey;
  cursor: pointer;
}
</style>
